import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
} from "@material-ui/core";

interface PatientRelationDialogProps {
  open: boolean;
  doctorName: string;
  patientRelationType: "NEW" | "EXISTING_MIGRATE";
  onRelationTypeChange: (value: "NEW" | "EXISTING_MIGRATE") => void;
  onConfirm: () => void;
  onCancel: () => void;
}

const PatientRelationDialog = ({
  open,
  doctorName,
  patientRelationType,
  onRelationTypeChange,
  onConfirm,
  onCancel,
}: PatientRelationDialogProps) => {
  return (
    <Dialog
      open={open}
      onClose={onCancel}
      maxWidth="xs"
      fullWidth
      disableBackdropClick
      disableEscapeKeyDown
    >
      <DialogTitle>Patient Registration Type</DialogTitle>

      <DialogContent dividers>
        <p style={{ color: "#666", fontSize: 14, marginBottom: 16 }}>
          Please select the relationship of this patient with{" "}
          <strong>{doctorName}</strong>
        </p>

        <FormControl component="fieldset" fullWidth>
          <RadioGroup
            value={patientRelationType}
            onChange={(e) =>
              onRelationTypeChange(e.target.value as "NEW" | "EXISTING_MIGRATE")
            }
          >
            <FormControlLabel
              value="NEW"
              control={<Radio color="primary" />}
              label={
                <div>
                  <div style={{ fontWeight: 600, fontSize: 14 }}>
                    This is a new patient for {doctorName}
                  </div>
                  <div style={{ fontSize: 12, color: "#888" }}>
                    यह {doctorName} के लिए नए मरीज़ हैं
                  </div>
                </div>
              }
              style={{
                border: `2px solid ${patientRelationType === "NEW" ? "#1976d2" : "#e0e0e0"}`,
                borderRadius: 8,
                padding: "10px 12px",
                marginBottom: 12,
                marginLeft: 0,
                marginRight: 0,
                transition: "border-color 0.15s",
              }}
            />
            <FormControlLabel
              value="EXISTING_MIGRATE"
              control={<Radio color="primary" />}
              label={
                <div>
                  <div style={{ fontWeight: 600, fontSize: 14 }}>
                    {doctorName} is already treating this patient
                  </div>
                  <div style={{ fontSize: 12, color: "#888" }}>
                    यह मरीज़ पहले से {doctorName} से इलाज करा रहे हैं
                  </div>
                </div>
              }
              style={{
                border: `2px solid ${patientRelationType === "EXISTING_MIGRATE" ? "#1976d2" : "#e0e0e0"}`,
                borderRadius: 8,
                padding: "10px 12px",
                marginLeft: 0,
                marginRight: 0,
                transition: "border-color 0.15s",
              }}
            />
          </RadioGroup>
        </FormControl>
      </DialogContent>

      <DialogActions>
        <Button onClick={onCancel}>Cancel</Button>
        <Button variant="contained" color="primary" onClick={onConfirm}>
          Continue
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PatientRelationDialog;
